import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { useJWPlayerEvent } from './useJWPlayerEvent';

export const useViewable = () => {
  const player = usePlayer();
  const jw = player.getJWPlayer();
  const [isViewable, setIsViewable] = useState(Boolean(jw?.getViewable()));

  const handleViewable = useCallback((param: jwplayer.ViewableParam) => {
    setIsViewable(Boolean(param.viewable));
  }, []);

  useJWPlayerEvent('viewable', handleViewable);

  return { isViewable };
};
